import { WeaTools } from 'ecCom';
export const newUrl = '/api/cube/timeline/'
export const CallAPI = (url, method, params) => {
    return new Promise((resolve, reject) => {
        WeaTools.callApi(url, method, params).then(({ noRight, ...data }) => {
            if (noRight) {
                resolve({ noRight, ...data } as any)
            } else {
                resolve(data as any)
            }
        })
    })
}

export const getDatas = (params) => {
    return CallAPI(`${newUrl}getDatas`, "get", params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/apis/timeline.ts